import { Mail, MapPin } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  const NAV_LINKS = [
    { label: "Servicios", href: "#servicios" },
    { label: "Identidad", href: "#identidad" },
    { label: "Diferencial", href: "#diferencial" },
    { label: "Estrategia", href: "#metodo" },
    { label: "Contacto", href: "#contacto" },
  ];

  const scrollTo = (href) => {
    if (!isHome) {
      navigate("/" + href);
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-calle-primary text-white pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-12 pb-8 border-b border-white/10">
          <Link to="/" className="flex items-center gap-3 mb-6 md:mb-0">
            <img 
              src="/images/calle-logo-dark.png" 
              alt="Calle & Cía. Abogados" 
              className="h-14 w-auto invert brightness-0 contrast-200"
              style={{ filter: 'invert(1) brightness(2)' }}
            />
          </Link>
          <nav className="flex flex-wrap gap-6">
            {NAV_LINKS.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="text-white/60 hover:text-white text-sm transition-colors font-body"
              >
                {link.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div>
            <h4 className="text-xs uppercase tracking-wider text-white/40 mb-4 font-semibold font-body">Ubicación</h4>
            <div className="flex items-center gap-2 text-white/70">
              <MapPin className="h-4 w-4" />
              <span className="font-body text-sm">Santiago, Chile</span>
            </div>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-wider text-white/40 mb-4 font-semibold font-body">Contacto</h4>
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-white/70" />
              <a 
                href="mailto:administracion@calleycia.cl" 
                data-testid="footer-email" 
                className="text-white/70 hover:text-white text-sm transition-colors font-body"
              >
                administracion@calleycia.cl
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-wider text-white/40 mb-4 font-semibold font-body">Especialidad</h4>
            <p className="text-white/70 text-sm font-body">
              Recuperación judicial de créditos morosos para bancos e instituciones financieras.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-xs text-center md:text-left font-body">
              © {new Date().getFullYear()} Calle & Cía. Abogados. Todos los derechos reservados.
            </p>
            <p className="text-white/30 text-xs text-center md:text-right font-body">
              Santiago, Chile
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
